export const CONSENT_TEXT = 'I’m 16 or older, and I agree PainPal may process my heart rate and activity data to work out my training numbers.';
export const CONSENT_REQUIRED = 'Tick the box to agree before you continue.';
const PENDING_KEY = 'painpal.consentPending';

// The box is ticked before there is a session to store it on, so the agreement rides along in this tab until the
// app records it: noted once an email sign-up has created the account, or as Strava sign-in leaves. Landing back on
// sign-in means that attempt ended, so the note is dropped there and never reaches a different account.
export function notePendingConsent(): void {
  sessionStorage.setItem(PENDING_KEY, '1');
}

export function takePendingConsent(): boolean {
  const pending = sessionStorage.getItem(PENDING_KEY) !== null;
  sessionStorage.removeItem(PENDING_KEY);
  return pending;
}
